import { Tabs, Tab, Box } from "@mui/material";
import React, { useState, ReactNode, useEffect, useRef } from "react";

interface EntityEditTabsProps {
  tabs: {
    label: string;
    content: ReactNode;
  }[];
}

const EntityEditTabs: React.FC<EntityEditTabsProps> = ({ tabs }) => {
  const [tab, setTab] = useState(0);

  const mountedTabs = useRef<Set<number>>(new Set([0]));

  const handleChange = (_: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
    mountedTabs.current.add(newValue);
  };

  return (
    <Box sx={{ width: "100%", py: 3 }}>
      <Tabs value={tab} onChange={handleChange} sx={{ mb: 3 }}>
        {tabs.map((tabItem, idx) => (
          <Tab key={idx} label={tabItem.label} />
        ))}
      </Tabs>

      {tabs.map((tabItem, idx) => {
        const isActive = tab === idx;
        const hasBeenMounted = mountedTabs.current.has(idx);

        return hasBeenMounted ? (
          <div
            key={idx}
            role="tabpanel"
            hidden={!isActive}
            style={{ display: isActive ? "block" : "none" }}
          >
            <Box sx={{ pt: 2 }}>{tabItem.content}</Box>
          </div>
        ) : null;
      })}
    </Box>
  );
};

export default EntityEditTabs;
